"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.saveConfiguration = exports.patchConfiguration = exports.setConfiguration = exports.resetConfiguration = void 0;

var _redux = require("../../helpers/redux");

var resetConfiguration = (0, _redux.createAction)("CONFIGURATION/resetConfiguration");
exports.resetConfiguration = resetConfiguration;
var setConfiguration = (0, _redux.createAction)("CONFIGURATION/setConfiguration");
exports.setConfiguration = setConfiguration;
var patchConfiguration = (0, _redux.createAction)("CONFIGURATION/patchConfiguration");
exports.patchConfiguration = patchConfiguration;
var saveConfiguration = (0, _redux.createAction)("CONFIGURATION/saveConfiguration");
exports.saveConfiguration = saveConfiguration;
var _default = {
  resetConfiguration: resetConfiguration,
  saveConfiguration: saveConfiguration,
  setConfiguration: setConfiguration,
  patchConfiguration: patchConfiguration
};
exports["default"] = _default;